import { ReactElement } from 'react';

import { ConfirmationModal } from '@/components/modals';

type DeleteUserImageDialogProps = {
  open: boolean;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
  imageType: 'profile' | 'signature';
};

export const DeleteUserImageDialog = ({
  open,
  isPending,
  onClose,
  onConfirm,
  imageType,
}: DeleteUserImageDialogProps): ReactElement => {
  return (
    <ConfirmationModal
      open={open}
      isPending={isPending}
      onClose={onClose}
      title={`Delete ${imageType === 'profile' ? 'Profile Picture' : 'Signature'}?`}
      content={`Are you sure you want to delete your ${imageType}? This action cannot be undone.`}
      cancelActionTitle="Cancel"
      confirmActionTitle="Delete"
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  );
};
